import classNames from 'classnames'

import { TypeCloudinaryImageJSON } from 'hello_baby/types/guides'
import {
  cloudinaryImageURL,
  cloudinaryAspectRatioTransform,
} from 'hello_baby/lib/cloudinary'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Image } from 'baby-design'
import RichTextBody from 'hello_baby/components/RichTextBody'

import { Document } from '@contentful/rich-text-types'

import css from './Image.styles.scss'

export interface TypePostEmbedImageFields {
  format: 'Normal' | 'Left' | 'Right'
  image: TypeCloudinaryImageJSON | TypeCloudinaryImageJSON[]
  altText: string
  galleryCaption?: Document
  imageTitle: string
  href?: string
}

interface ImageProps {
  fields: TypePostEmbedImageFields
  aspectRatio?: number
  initialUrl: string
}

interface EmbedImageProps {
  fields: TypePostEmbedImageFields
  aspectRatio?: number
}

const WrappedImage = ({ fields, aspectRatio, initialUrl }: ImageProps) => {
  let aspectRatioStyle = {}
  let url = initialUrl

  if (aspectRatio && url.search('ar_') === -1) {
    url = cloudinaryAspectRatioTransform(url, aspectRatio)

    aspectRatioStyle = {
      aspectRatio,
      width: '100%',
    }
  }

  return (
    <figure
      className={classNames({
        [css.figure_image_wrapping]:
          fields.format === 'Right' || fields.format === 'Left',
      })}
    >
      <Image
        alt={fields.altText || 'Babylist Guides Image'}
        className={classNames('img-responsive', {
          [css.wrap_right_image]: fields.format === 'Right',
          [css.wrap_left_image]: fields.format === 'Left',
        })}
        src={url}
        style={aspectRatioStyle}
      />
      <figcaption className={classNames(css.captionText)}>
        {fields.galleryCaption && (
          <RichTextBody richTextBody={fields.galleryCaption} />
        )}
      </figcaption>
    </figure>
  )
}

const EmbedImage: React.FC<EmbedImageProps> = ({
  fields,
  aspectRatio,
}: EmbedImageProps) => {
  const url = cloudinaryImageURL(fields.image)
  if (!url) return null

  if (fields.href) {
    return (
      <a className={css.link} href={fields.href} rel="noopener" target="_blank">
        <WrappedImage
          aspectRatio={aspectRatio}
          fields={fields}
          initialUrl={url}
        />
      </a>
    )
  }
  return (
    <WrappedImage aspectRatio={aspectRatio} fields={fields} initialUrl={url} />
  )
}

export default EmbedImage
